import { gql } from '@apollo/client';

export const GET_TRACK_TABLE_ROWS_FOR_UNMATCHED = gql`
    query getWorksTableRowsForUnmatched($user_id: String!) {
        getWorksTableRowsForUnmatched(user_id: $user_id) {
            id
            asset_url
            detection_status
            earnings
            percent_share
            performance_count
            title
            work_ids
        }
    }
`;
